module.exports = __webpack_public_path__ + "img/violet_124.001f571c.png";